module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_12.2e71bc27.png";